$bog_dobro_app $mol_book2_catalog
	Placeholder null
	Menu_logo $mol_image
		uri \bog/dobro/assets/icon.jpg
	menu_title @ \Goodness is near 
	menu_tools /
		<= Theme_toggle $bog_theme_toggle
			theme_auto <= Theme 
	plugins /
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_light
			theme_dark \$mol_theme_dark
	spreads *
		\	
			<= Bot $giper_bot
				Space null
				Sources null
				Donate null
				Support null
				Lights null
		prof <= Prof $bog_dobro_app_prof
		charity <= Charity $bog_dobro_app_charity
		settings <= Settings $bog_dobro_app_settings
		vaka <= Vaka $bog_dobro_app_vaka
		ainews <= Ainews $bog_ainews_app
			menu_tools /
			param null
			Theme null
